/**
 * Determines whether to use Firebase or Mock authentication based on environment variables
 */
export function shouldUseFirebaseAuth(): boolean {
  // Default to Firebase in production and test environments
  if (import.meta.env.VITE_ENVIRONMENT === 'production') {
    return true;
  }

  // Allow explicit override via environment variable
  const useFirebaseEnv = import.meta.env.VITE_USE_FIREBASE_AUTH;
  if (useFirebaseEnv !== undefined) {
    return useFirebaseEnv === 'true';
  }

  // Default to mock auth in development
  return false;
}
